/**
 * Image Zoom on Hover – Desktop Only
 *
 * Uses CSS transform: scale() on the <img> itself instead of an overlay div.
 * This avoids all issues with:
 *   - SVG clip-path on images (blob shape)
 *   - Slick slider DOM cloning & event interception
 *   - Overlay positioning / z-index problems
 *
 * Document-level capture-phase listeners guarantee events are received
 * regardless of Slick's internal stopPropagation calls.
 */
(function () {
  'use strict';

  var ZOOM_RATIO = 2;
  var MIN_DESKTOP_WIDTH = 992;

  var activeImage = null;
  var activeContainer = null;

  /* ─── helpers ─── */

  function isDesktop() {
    return window.innerWidth >= MIN_DESKTOP_WIDTH;
  }

  /**
   * From any event-target, walk up to find the nearest
   * img.image-magnify-hover inside a .product__slider-display.
   */
  function findZoomImage(target) {
    if (!target || typeof target.closest !== 'function') return null;

    var img = null;

    if (target.matches && target.matches('img.image-magnify-hover')) {
      img = target;
    } else {
      var wrapper = target.closest('.slider-item .image');
      if (wrapper) {
        img = wrapper.querySelector('img.image-magnify-hover');
      }
    }

    if (img && img.closest('.product__slider-display')) return img;
    return null;
  }

  /* ─── zoom lifecycle ─── */

  function activateZoom(img) {
    activeImage = img;
    activeContainer = img.closest('.image') || img.parentElement;

    // Container must clip the scaled image
    if (activeContainer) {
      activeContainer.style.overflow = 'hidden';
      activeContainer.style.position = 'relative';
    }

    // Remove the blob clip-path so the zoom shows a clean rectangle
    img.style.clipPath = 'none';
    img.style.webkitClipPath = 'none';

    // Scale up from center initially
    img.style.transform = 'scale(' + ZOOM_RATIO + ')';
    img.style.transformOrigin = '50% 50%';
    img.style.willChange = 'transform';
    img.style.cursor = 'zoom-out';
  }

  function updateZoom(e) {
    if (!activeImage || !activeContainer) return;

    // Use the CONTAINER rect (stable – not affected by img transform)
    var rect = activeContainer.getBoundingClientRect();
    var x = ((e.clientX - rect.left) / rect.width) * 100;
    var y = ((e.clientY - rect.top) / rect.height) * 100;

    x = Math.max(0, Math.min(100, x));
    y = Math.max(0, Math.min(100, y));

    activeImage.style.transformOrigin = x + '% ' + y + '%';
  }

  function deactivateZoom() {
    if (!activeImage) return;

    activeImage.style.clipPath = '';
    activeImage.style.webkitClipPath = '';
    activeImage.style.transform = '';
    activeImage.style.transformOrigin = '';
    activeImage.style.willChange = '';
    activeImage.style.cursor = '';

    if (activeContainer) {
      activeContainer.style.overflow = '';
      activeContainer.style.position = '';
    }

    activeImage = null;
    activeContainer = null;
  }

  /* ─── event listeners (capture phase on document) ─── */

  // Single mousemove handles enter / move / leave detection
  document.addEventListener('mousemove', function (e) {
    if (!isDesktop()) {
      if (activeImage) deactivateZoom();
      return;
    }

    var img = findZoomImage(e.target);

    if (img) {
      if (img !== activeImage) {
        deactivateZoom();
        activateZoom(img);
      }
      updateZoom(e);
    } else if (activeImage) {
      deactivateZoom();
    }
  }, true);

  // Prevent Slick drag while zoom is active
  document.addEventListener('mousedown', function (e) {
    if (!activeImage) return;
    var img = findZoomImage(e.target);
    if (img === activeImage) {
      e.stopPropagation();
      e.preventDefault();
    }
  }, true);

  // Clean up when cursor leaves the viewport
  document.addEventListener('mouseleave', function () {
    if (activeImage) deactivateZoom();
  }, true);

  // Expose globally so product-info.js can call after variant change
  window.enableZoomOnHover = function () {};
  window.initZoomOnHover = function () {};
})();
